var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-badge',{attrs:{"pill":"","variant":"danger"}},[_vm._v("Não aprovado")])}
var staticRenderFns = []

export { render, staticRenderFns }